<tui-root>
  <iss-global-spinner [visible]="globalSpinnerVisible$ | async">
    <iss-side-nav-container>
      <iss-side-nav
        *ngIf="isAuthorized$ | async"
        [expanded]="expanded$ | async"
        (expandedChange)="toggleSideNav()"
      >
        <iss-side-nav-header (toggle)="toggleSideNav()">{{ header }}</iss-side-nav-header>
        <iss-side-nav-menu-item
          [title]="'page.order-list' | translate"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="AppRoutingLinks.orders()"
          iconName="clipboard-list" data-e2e="order list button"
        />
        <iss-side-nav-menu-item
          *ngIf="true | ifHasPermission:'can create a new order'"
          [title]="'page.new-order' | translate"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="AppRoutingLinks.newOrder()"
          [state]="{ shouldClearState: true }"
          iconName="add_order" data-e2e="new order button"
        />
        <ng-container *ngIf="isMobileRes$ | async | isFalse">
          <iss-side-nav-menu-item
            *ngIf="hasRequiredSupplierContext$ | async | ifHasPermission:'can manage upload weight'"
            [title]="'Upload weights'"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            [routerLink]="AppRoutingLinks.uploadWeight()"
            iconName="invoice" data-e2e="upload weight button"
          />
          <iss-side-nav-menu-item
            *ngIf="true | ifHasPermission:'can manage suppliers'"
            [title]="'page.suppliers' | translate"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: false }"
            [routerLink]="AppRoutingLinks.suppliers()"
            iconName="truck" data-e2e="suppliers button"
          />
          <ng-container *ngIf="{ customers: true | ifHasPermission:'can manage customers', sites: true | ifHasPermission:'can manage sites' } as data">
            <ng-container *ngIf="data.customers && data.sites" [ngTemplateOutlet]="customersTpl"/>
            <ng-container *ngIf="data.customers && !data.sites" [ngTemplateOutlet]="customersTpl"/>
            <ng-container *ngIf="!data.customers && data.sites" [ngTemplateOutlet]="sitesTpl"/>
          </ng-container>
          <ng-template #customersTpl>
            <iss-side-nav-menu-item
              [title]="'page.customers' | translate"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              [routerLink]="AppRoutingLinks.customers()"
              iconName="building-community" data-e2e="customers button"
            />
          </ng-template>
          <ng-template #sitesTpl>
            <iss-side-nav-menu-item
              [title]="'page.sites' | translate"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: false }"
              [routerLink]="AppRoutingLinks.sites()"
              iconName="building-community" data-e2e="sites button"
            />
          </ng-template>
          <iss-side-nav-menu-item
            *ngIf="true | ifHasPermission:'can manage invoicing'"
            [title]="'page.invoicing' | translate"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="AppRoutingLinks.invoicing()"
            iconName="invoicing" data-e2e="invoicing button"
          />
        </ng-container>
        <iss-side-nav-menu-item
          *ngIf="true | ifHasPermission:'can manage reports'"
          [title]="'page.reports' | translate"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
          [routerLink]="AppRoutingLinks.reports()"
          iconName="calendar-due" data-e2e="reports button"
        />
        <iss-side-nav-menu-item
          *ngIf="true | ifHasPermission:'can manage admin page'"
          [title]="'page.admin' | translate"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: false }"
          [routerLink]="AppRoutingLinks.admin()"
          iconName="ruler" data-e2e="admin button"
        />
        <iss-side-nav-menu-item
          class="wo-app-component__logout"
          [title]="'auth.logout' | translate"
          (click)="logout()"
          iconName="logout"
        />
        <wo-contact-support/>
        <iss-portal-header
          [name]="username$ | async"
          [subtext]="(impersonateContext$ | async)?.impersonated ? 'Impersonation' : email$ | async"
        >
          <ng-container [ngTemplateOutlet]="avatarTpl"/>
        </iss-portal-header>
      </iss-side-nav>
      <wo-page-context-bar
        *ngIf="isAuthorized$ | async"
        issPageContextBar
      />
      <wo-page-mobile-app-bar
        *ngIf="isAuthorized$ | async"
        issPageMobileAppBar
        [header]="header"
        (toggle)="toggleSideNav()"
      >
        <ng-container [ngTemplateOutlet]="avatarTpl"/>
      </wo-page-mobile-app-bar>
      <wo-page-mobile-tab-bar
        *ngIf="isAuthorized$ | async"
        issPageMobileTabBar
      />
      <iss-page-title-bar/>
      <router-outlet/>
      <ng-template #avatarTpl>
        <wo-avatar-menu
          data-e2e = "account avatar"
          [impersonateContext]="impersonateContext$ | async"
          [canSeeSwitchContextPage]="canSeeSwitchContext$ | async"
          (goToAccount)="router.navigate(AppRoutingLinks.account())"
          (goToContext)="goToContext()"
          (logout)="logout()"
          (impersonation)="onImpersonation()"
        >
            <iss-avatar class="tw-cursor-pointer" [username]="username$ | async" />
        </wo-avatar-menu>
      </ng-template>
    </iss-side-nav-container>
  </iss-global-spinner>
</tui-root>
<wo-env-info *ngIf="isAuthorized$ | async"/>
